// NOTE: this module configures the shared axios instance as a side effect. It is
// listed in package.json "sideEffects" so bundlers never drop it (otherwise
// baseURL/withCredentials/params are unset and every request breaks).
import axios from 'axios';
import type { AxiosRequestTransformer } from 'axios';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT as string;

axios.defaults.baseURL = API_ENDPOINT;

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';
axios.defaults.headers.patch['Content-Type'] = 'application/json';

// Keep axios 0.x request bodies. Since 1.x the defaults above (Content-Type: application/json
// on every method) are merged in before the body transform, which then JSON-encodes what 0.x
// sent untouched: a plain string becomes "\"a@b.com\"" (the backend reads emails, ids and passwords
// as raw @RequestBody strings), null becomes "null", and FormData is converted to JSON. Pass those
// three through as-is; everything else gets the default transform.
const [defaultTransformRequest] = axios.defaults.transformRequest as AxiosRequestTransformer[];
axios.defaults.transformRequest = [
  function transformRequestLikeAxios0(data, headers) {
    if (typeof data === 'string' || data === null || data instanceof FormData) return data;
    return defaultTransformRequest.call(this, data, headers);
  },
];

axios.defaults.withCredentials = true;

axios.defaults.params = {};

axios.defaults.params.cacheBuster = new Date().getTime();

export default axios;
